export default __webpack_public_path__ + "static/winter6-6223b15553be4de4cd087147d97f3bb7.webp";